<template>
  <div
    v-if="width"
    style="position: relative;"
    :style="{ width: `${width}px` }"
  >
          <div
            v-if="height"
            style="position: absolute;"
            :style="{ width: `${width}px`, height: `${height}px`}"
          >
            <iframe
              :src="url.concat('?fm=true&share=true', localeQuery ? `&locale=${localeQuery}` : '')"
              style="overflow: hidden;"
              :style="{
                borderRadius: type === 'phone' ? `5%` : '0',
                'margin-top': `${calcSize(56)}px`,
                'margin-left': `${calcSize(60)}px`,

                width: `${originalSize.fw}px`,
                height: `${originalSize.fh}px`,
                '-ms-zoom': !iframeScale ? null : iframeScale,
                '-moz-transform': !iframeScale ? null : `scale(${iframeScale})`,
                '-moz-transform-origin': !iframeScale ? null : '0 0',
                '-o-transform': !iframeScale ? null : `scale(${iframeScale})`,
                '-o-transform-origin': !iframeScale ? null : '0 0',
                '-webkit-transform': !iframeScale ? null : `scale(${iframeScale})`,
                '-webkit-transform-origin': !iframeScale ? null : '0 0',
              }"
            />
          </div>
          <div
            style="pointer-events: none;position: absolute;"
            :style="{ width: `${width}px` }"
          >
            <v-img
              :src="frame"
            />
          </div>
  </div>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: null,
    },
    url: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'phone',
    },
  },
  data: () => ({
    iframeScale: null,
    height: null,
  }),
  computed: {
    scale () {
      return (this.width-60) / this.originalSize.w
    },
    originalSize () {
      return {
          /*
          w: 785,
          h: 1617,
          fw: 375,
          fh: 790,
          */
          w: 785,
          h: 1617,
          fw: 380,
          fh: 810,
          //fw: 380,
          //fh: 810,
        }
    },
    frame () {
      return  'https://totem.dtouchwebapp.com/media/phonebg.png'
    },
    localeQuery () {
      return this.$route.query.locale
    },
  },
  watch: {
    width () {
      this.init()
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const aux = this.calcSize(115)
      this.iframeScale = (this.width-aux) / this.originalSize.fw// (this.width) / (this.originalSize.w - aux)
      this.height = this.calcSize(this.originalSize.h)
    },
    calcSize (v) {
      return v * this.scale
    },
  },
}
</script>
